(function () {
  if (window.__brizaCartBound) return;
  window.__brizaCartBound = true;

  var labels = { added: 'Zum Warenkorb hinzugefügt' };

  function routesRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function submitCart(items, btn) {
    if (btn) { btn.classList.add('is-loading'); btn.disabled = true; }
    var routes = routesRoot();

    var sections = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections',
      { bubbles: true, detail: { sections: sections } }));

    fetch(routes + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items, sections: sections.join(',') })
    })
      .then(function (res) {
        if (!res.ok) { return res.json().then(function (e) { throw e; }); }
        return res.json();
      })
      .then(function (responseJson) {
        return fetch(routes + 'cart.js').then(function (r) { return r.json(); }).then(function (cart) {
          cart.sections = responseJson.sections;
          document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
            bubbles: true,
            detail: { baseEvent: 'variant:add', cart: cart }
          }));
          toast(labels.added);
        });
      })
      .catch(function (err) {
        console.error('briza cart error', err);
        toast((err && err.description) || 'Etwas ist schiefgelaufen.');
      })
      .finally(function () {
        if (btn) { btn.classList.remove('is-loading'); btn.disabled = false; }
      });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('.briza-cards__form, .briza-pcard__form');
    if (!form) return;
    e.preventDefault();
    var input = form.querySelector('input[name="id"]');
    if (!input || !input.value) return;
    var id = parseInt(input.value, 10);
    if (!id) return;
    submitCart([{ id: id, quantity: 1 }], form.querySelector('button[type="submit"]'));
  });

  /* ---------- toast (aus deinem Bundle Builder übernommen) ---------- */
  var toastEl;
  function toast(msg) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.style.cssText = 'position:fixed;left:50%;bottom:26px;transform:translateX(-50%) translateY(20px);' +
        'background:#262321;color:#fff;padding:13px 22px;border-radius:30px;font-size:13px;z-index:9999;' +
        'opacity:0;transition:.3s;pointer-events:none;';
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    requestAnimationFrame(function () {
      toastEl.style.opacity = '1'; toastEl.style.transform = 'translateX(-50%) translateY(0)';
    });
    clearTimeout(toast._t);
    toast._t = setTimeout(function () {
      toastEl.style.opacity = '0'; toastEl.style.transform = 'translateX(-50%) translateY(20px)';
    }, 2600);
  }
})(); 